'use es6';

export function findCustomWidget(layoutWidget, customWidgetsData) {
  if (!layoutWidget.params) {
    return null;
  }

  const {
    custom_widget_id: customWidgetId,
    path,
    module_id: moduleId,
    widget_name: name
  } = layoutWidget.params;

  if (customWidgetId && customWidgetsData[customWidgetId]) {
    return customWidgetsData[customWidgetId];
  }

  if (path || moduleId || name) {
    let widget;

    for (const wgt of Object.values(customWidgetsData)) {
      if (path && wgt.path === path || moduleId && wgt.moduleId === moduleId) {
        widget = wgt;
        break;
      } // `name` is a deprecated reference.  `name` used to be a unique id, but no longer.
      // Using here as a fallback.
      // https://issues.hubspotcentral.com/browse/CG-14845
      // https://hubspot.slack.com/archives/CGAKVNT6G/p1579103258221300


      if (name && wgt.name === name) {
        widget = wgt;

        if (!path && !moduleId) {
          break;
        }
      }
    }

    if (widget) return widget;
  }

  return null;
}